import { z } from "zod";
import { IdType } from "./base.validator";

export enum UserActivity {
	Online = "Online",
	Idle = "Idle",
	Offline = "Offline",
}

export const createdUserStatus = z.object({
	id: IdType,
	status: z.string().nullable(),
	emoji: z.string().nullable(),
	until: z.string().datetime().nullable(),
	activity: z.nativeEnum(UserActivity),
});
export type CreatedUserStatusDto = z.infer<typeof createdUserStatus>;

export const updateUserStatusInput = createdUserStatus
	.partial()
	.omit({ id: true })
	.extend({
		status: createdUserStatus.shape.status.nullish(),
		emoji: createdUserStatus.shape.emoji.nullish(),
		until: createdUserStatus.shape.until.nullish(),
	});
export type UpdateUserStatusInputDto = z.infer<typeof updateUserStatusInput>;
